/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2018, 2019
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
const BasePinsPanel = require('gemini/pinning/PinsPanel');

const PinsPanel = BasePinsPanel.extend({
	_addPinToLayout: function({ model: widgetFragment }, isTouch) {

		const {
			layout: widgetLayout
		} = widgetFragment;

		let exploreCardFragment;
		if (widgetLayout.type === 'widget') {
			exploreCardFragment = {
				...widgetFragment,
				layout: {
					id: 'cardId',
					relatedLayouts: '',
					type: 'exploreCard',
					items: [
						{
							...widgetLayout,
							style: {}
						}
					]
				}
			};
		} else {
			exploreCardFragment = {
				...widgetFragment
			};
		}

		this.canvasController.addPin({
			model: exploreCardFragment
		}, isTouch);
	}
});

export default PinsPanel;



// WEBPACK FOOTER //
// ./src/js/glass/extensions/pinning/PinsPanel.js